import gql from "graphql-tag";

export const DELETE = gql`
  mutation deleteProduct($product_id: String!, $isDelOnStore: Boolean!) {
    deleteProduct(product_id: $product_id, isDelOnStore: $isDelOnStore)
  }
`;
